'use client';

import { createContext, useContext } from 'react';

export interface TenantInfo {
  id: string;
  name: string;
  slug: string;
  logo?: string | null;
  primaryColor?: string | null;
  accentColor?: string | null;
  heroHeadline?: string | null;
  heroSubtext?: string | null;
  heroImageUrl?: string | null;
  contact?: {
    phone?: string;
    email?: string;
    address?: string;
    city?: string;
    state?: string;
    zip?: string;
  } | null;
}

const TenantContext = createContext<TenantInfo | null>(null);

export function TenantProvider({
  tenant,
  children,
}: {
  tenant: TenantInfo;
  children: React.ReactNode;
}) {
  return (
    <TenantContext.Provider value={tenant}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant(): TenantInfo {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant must be used within TenantProvider');
  return ctx;
}
